<div class="thumbnail">
  <!-- <object class="media-object avatar-image" data="https://images-na.ssl-images-amazon.com/images/I/218eLEn0fuL.png" type="image/jpg"></object> -->
  <object class="avatar-image" [data]="avatarUrl | safeUrl" *ngIf="!!avatarUrl" type="image/jpg" typemustmatch="true"></object>
  <div class="avatar-image-placeholder" *ngIf="!avatarUrl"></div>

  <div class="caption">
    <h5>{{ person.displayName$ | async }}</h5>
  </div>
</div>
